(function () {
  'use strict';

  var root = document.documentElement;
  var STORE_KEY = 'kf-theme';

  /* Light and dark mode */
  function currentMode() { return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'; }

  function syncMode() {
    var dark = currentMode() === 'dark';
    var buttons = document.querySelectorAll('[data-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('aria-pressed', dark ? 'true' : 'false');
    var meta = document.querySelector('meta[name="theme-color"]');
    var bg = getComputedStyle(root).getPropertyValue('--c-bg').trim();
    if (meta && bg) meta.setAttribute('content', bg);
  }

  function setMode(mode, remember) {
    root.setAttribute('data-theme', mode);
    if (remember) { try { localStorage.setItem(STORE_KEY, mode); } catch (e) {} }
    syncMode();
  }

  if (window.matchMedia) {
    var schemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    var followDevice = function () {
      var saved = null;
      try { saved = localStorage.getItem(STORE_KEY); } catch (e) {}
      if (saved || root.getAttribute('data-default-mode') !== 'system') return;
      setMode(schemeQuery.matches ? 'dark' : 'light', false);
    };
    if (schemeQuery.addEventListener) schemeQuery.addEventListener('change', followDevice);
    else if (schemeQuery.addListener) schemeQuery.addListener(followDevice);
  }
  syncMode();

  /* Clicks: mode toggle and mobile menu */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-theme-toggle]');
    if (toggle) {
      setMode(currentMode() === 'dark' ? 'light' : 'dark', true);
      return;
    }
    var menu = e.target.closest('[data-menu-toggle]');
    if (menu) {
      var drawer = document.getElementById(menu.getAttribute('aria-controls'));
      var open = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (drawer) drawer.classList.toggle('is-open', !open);
    }
  });

  /* Changes: variant picker, cart quantities, collection sorting */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches) return;
    if (t.matches('[data-variant]')) {
      var form = t.closest('[data-product-form]');
      if (!form) return;
      var input = form.querySelector('[data-variant-input]');
      var price = form.querySelector('[data-price]');
      var add = form.querySelector('[data-add]');
      var ok = t.getAttribute('data-available') === 'true';
      if (input) input.value = t.value;
      if (price) price.textContent = t.getAttribute('data-price');
      if (add) {
        add.disabled = !ok;
        add.textContent = ok ? add.getAttribute('data-add-label') : add.getAttribute('data-sold-label');
      }
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', t.value);
        history.replaceState(null, '', u.toString());
      } catch (err) {}
    } else if (t.matches('[data-autosubmit]') && t.form) {
      t.form.submit();
    } else if (t.matches('[data-sort]')) {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', t.value);
      url.searchParams.delete('page');
      location.href = url.toString();
    }
  });

  /* 3D orbit of floating icons */
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var BASE_TILT = -20;

  function createOrbit(el) {
    var scene = el.querySelector('[data-orbit-scene]');
    var core = el.querySelector('[data-orbit-core]');
    var tiles = Array.prototype.slice.call(el.querySelectorAll('[data-orbit-tile]'));
    var count = tiles.length;
    if (!scene || !count) return null;

    var speedSetting = parseFloat(el.getAttribute('data-speed'));
    if (isNaN(speedSetting)) speedSetting = 2;
    var baseSpeed = reduceMotion ? 0 : speedSetting * 5; // degrees per second
    var step = 360 / count;
    var radius = 160;
    var angle = 0;
    var velocity = baseSpeed;
    var tiltX = BASE_TILT, tiltZ = 0, aimX = BASE_TILT, aimZ = 0;
    var dragging = false, moved = false, pointerId = null;
    var startX = 0, startAngle = 0, lastMoveT = 0, lastMoveAngle = 0;
    var holding = false, inView = false, running = false;
    var raf = 0, lastT = 0, t0 = performance.now();

    function measure() {
      var w = el.clientWidth, h = el.clientHeight;
      radius = Math.max(100, Math.min(w * 0.4, h * 0.48, 260));
      scene.style.setProperty('--r', radius.toFixed(1) + 'px');
    }

    function draw(time) {
      scene.style.transform = 'rotateZ(' + tiltZ.toFixed(2) + 'deg) rotateX(' + tiltX.toFixed(2) + 'deg)';
      // undo the scene tilt so the core and the icons always face the viewer
      var face = ' rotateX(' + (-tiltX).toFixed(2) + 'deg) rotateZ(' + (-tiltZ).toFixed(2) + 'deg)';
      if (core) core.style.transform = face;
      for (var i = 0; i < count; i++) {
        var a = (angle + i * step) * Math.PI / 180;
        var x = Math.sin(a) * radius;
        var z = Math.cos(a) * radius;
        var y = reduceMotion ? 0 : Math.sin(time * 1.2 + i * 1.9) * 7;
        var depth = (Math.cos(a) + 1) / 2;
        var tile = tiles[i];
        tile.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,' + z.toFixed(1) + 'px)' + face;
        tile.style.opacity = (0.45 + depth * 0.55).toFixed(3);
        tile.style.setProperty('--d', depth.toFixed(3));
      }
    }

    function tick(now) {
      var dt = Math.min((now - lastT) / 1000, 0.05);
      lastT = now;
      var time = (now - t0) / 1000;
      if (!dragging) {
        var target = holding ? 0 : baseSpeed;
        velocity += (target - velocity) * (1 - Math.exp(-dt * 2.2));
        angle += velocity * dt;
      }
      if (!finePointer && !reduceMotion) {
        aimX = BASE_TILT + Math.sin(time * 0.5) * 3;
        aimZ = Math.sin(time * 0.35) * 2;
      }
      var k = 1 - Math.exp(-dt * 5);
      tiltX += (aimX - tiltX) * k;
      tiltZ += (aimZ - tiltZ) * k;
      draw(time);
      raf = requestAnimationFrame(tick);
    }

    function start() {
      if (running || !inView || document.hidden) return;
      running = true;
      lastT = performance.now();
      raf = requestAnimationFrame(tick);
    }

    function stop() {
      running = false;
      cancelAnimationFrame(raf);
    }

    function onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      moved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startAngle = angle;
      lastMoveT = performance.now();
      lastMoveAngle = angle;
      velocity = 0;
    }

    function onMove(e) {
      if (dragging && e.pointerId === pointerId) {
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          el.classList.add('is-dragging');
          try { el.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) {
          angle = startAngle + dx * 0.35;
          var now = performance.now();
          var dtm = Math.max(now - lastMoveT, 8) / 1000;
          velocity = velocity * 0.5 + ((angle - lastMoveAngle) / dtm) * 0.5;
          lastMoveT = now;
          lastMoveAngle = angle;
          if (!running) draw((now - t0) / 1000);
        }
        return;
      }
      if (finePointer && e.pointerType === 'mouse') {
        var r = el.getBoundingClientRect();
        aimX = BASE_TILT - ((e.clientY - r.top) / r.height - 0.5) * 10;
        aimZ = -((e.clientX - r.left) / r.width - 0.5) * 6;
      }
    }

    function onUp(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      dragging = false;
      el.classList.remove('is-dragging');
      try { el.releasePointerCapture(e.pointerId); } catch (err) {}
      if (performance.now() - lastMoveT > 120) velocity = 0; // the finger rested before lifting
      velocity = Math.max(-400, Math.min(400, velocity));
    }

    function onLeave() {
      aimX = BASE_TILT;
      aimZ = 0;
      holding = false;
    }

    function onClick(e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }

    function onOver(e) {
      if (e.pointerType === 'mouse' && e.target.closest('[data-orbit-tile]')) holding = true;
    }

    function onOut(e) {
      if (e.pointerType !== 'mouse' || !e.target.closest('[data-orbit-tile]')) return;
      var next = e.relatedTarget;
      if (!(next && next.closest && next.closest('[data-orbit-tile]'))) holding = false;
    }

    function onFocusIn(e) {
      var tile = e.target.closest('[data-orbit-tile]');
      if (!tile) return;
      var keyboard = true;
      try { keyboard = tile.matches(':focus-visible'); } catch (err) {}
      if (!keyboard) return;
      holding = true;
      angle = -tiles.indexOf(tile) * step; // bring the focused icon to the front
      if (!running) draw((performance.now() - t0) / 1000);
    }

    function onFocusOut() { holding = false; }
    function onDragStart(e) { e.preventDefault(); }
    function onVisibility() { if (document.hidden) stop(); else start(); }

    el.addEventListener('pointerdown', onDown);
    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerup', onUp);
    el.addEventListener('pointercancel', onUp);
    el.addEventListener('pointerleave', onLeave);
    el.addEventListener('pointerover', onOver);
    el.addEventListener('pointerout', onOut);
    el.addEventListener('click', onClick, true);
    el.addEventListener('focusin', onFocusIn);
    el.addEventListener('focusout', onFocusOut);
    el.addEventListener('dragstart', onDragStart);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('resize', measure);

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        inView = entries[entries.length - 1].isIntersecting;
        if (inView) start(); else stop();
      });
      observer.observe(el);
    } else {
      inView = true;
      start();
    }

    measure();
    draw(0);
    el.classList.add('is-ready');

    return function destroy() {
      stop();
      if (observer) observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('resize', measure);
    };
  }

  function initOrbits(scope) {
    var list = (scope || document).querySelectorAll('[data-orbit]');
    for (var i = 0; i < list.length; i++) {
      if (!list[i]._kfOrbit) list[i]._kfOrbit = createOrbit(list[i]) || function () {};
    }
  }

  function destroyOrbits(scope) {
    var list = (scope || document).querySelectorAll('[data-orbit]');
    for (var i = 0; i < list.length; i++) {
      if (list[i]._kfOrbit) {
        list[i]._kfOrbit();
        list[i]._kfOrbit = null;
      }
    }
  }

  initOrbits();
  document.addEventListener('shopify:section:load', function (e) { initOrbits(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyOrbits(e.target); });
})();
